import { useIntl } from 'react-intl';
import { Button } from 'antd';

import { CheckOutlined } from '@ant-design/icons';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import InfiniteTable, { ColumnsType } from '@/components/_common/InfiniteTable';

import { useCustomerReducedList } from '@/core/domain/people/Customers/Customers.hooks';
import { CustomerReduced } from '@/core/domain/people/Customers/Customers.types';
import { COLUMNS_WIDTH, getTableScrollX } from '@/utils/table';

interface Props {
  handleSelect: (name: string, id: number) => void;
}

function CustomersList({ handleSelect }: Props) {
  const intl = useIntl().formatMessage;
  const { data, isFetching, hasNextPage, fetchNextPage } =
    useCustomerReducedList();
  const listagem = flatInfiniteData(data);

  const columns: ColumnsType<CustomerReduced> = [
    {
      title: 'CPF/CNPJ',
      dataIndex: 'cpfCnpj',
      key: 'cpfCnpj',
      width: COLUMNS_WIDTH.document,
      ellipsis: true,
    },
    {
      title: intl({
        id: 'layout.menu.fiscal.invoice.referenced.list.name',
      }),
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: COLUMNS_WIDTH.default,
    },
    {
      dataIndex: 'actions',
      align: 'center',
      width: COLUMNS_WIDTH.small,
      fixed: 'right',
      render: (_, row) => (
        <Button
          type="primary"
          onClick={() => handleSelect(row.name, row.id)}
          icon={<CheckOutlined />}
        />
      ),
    },
  ];
  return (
    <InfiniteTable
      columns={columns}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      loading={isFetching}
      dataSource={listagem}
      rowKey={(row) => row.id}
      scroll={{ x: getTableScrollX(columns) }}
    />
  );
}

export default CustomersList;
